
export default function ValueProposition() {
  const values = [
    {
      icon: 'ri-flask-line',
      title: '功能价值',
      description: '科学、有效、安全的产品解决方案，专业研究院背书保障'
    },
    {
      icon: 'ri-heart-3-line',
      title: '情感价值',
      description: '陪伴、鼓励、不焦虑的温暖体验，哈乐猴与你一起轻松前行'
    },
    {
      icon: 'ri-star-smile-line',
      title: '精神价值',
      description: '追求轻盈健康的过程本身，就是一种值得享受的积极人生'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-b from-white to-[#f8f9fc]">
      <div className="max-w-7xl mx-auto px-6 lg:px-32">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-2xl lg:text-4xl font-light text-gray-800 mb-4 lg:mb-6">
            三位一体的核心价值
          </h2>
          <p className="text-sm lg:text-lg text-gray-600 font-light max-w-3xl mx-auto">
            不再贩卖身材的"焦虑"，而是倡导身体和心理的"快乐"<br />
            不再强调"快结果"，而是赋能"轻过程"
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {values.map((value, index) => (
            <div key={index} className="text-center group">
              <div className="w-16 lg:w-20 h-16 lg:h-20 mx-auto mb-6 lg:mb-8 bg-gradient-to-br from-[#847eba] to-[#a3c1c3] rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <i className={`${value.icon} text-xl lg:text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg lg:text-xl font-medium text-gray-800 mb-3 lg:mb-4">
                {value.title}
              </h3>
              <p className="text-xs lg:text-base text-gray-600 leading-relaxed font-light">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
